import { API_BASE_URL } from '../config/api';

/** Explicit exports may read all pages; ordinary page rendering never calls this. */
export async function loadHistoryForExport(apiCall, path) {
  const rows = [];
  let cursor;
  do {
    const response = await apiCall(`${API_BASE_URL}${path}${path.includes('?') ? '&' : '?'}limit=1000${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`);
    if (response?.error) throw new Error(response.error);
    rows.push(...(response.data || []));
    cursor = response.next_cursor;
  } while (cursor);
  return rows;
}
